

import _ from 'lodash';

/* @ngInject */
export default function financingFactory($http, HPConfig, $q) {
    let _states = null;
    let _currentRates = {}; // Rates that are currently being used
    let _scheduledRates = {}; // Rates that have been scheduled, but not yet in use
    const _allRates = {}; // All possible AllRates
    let _selectedRates = {}; // Rates that have been selected but not yet scheduled
    let _currentDate = '';
    let _selectedState;
    let _premierTier;

    return {
        getCurrentDate,
        getServiceStates,
        getDefaultPlanRates,
        getFinancingOptions,
        getAllPlanRates,
        getAllRates,
        getCurrentRates,
        getScheduledRates,
        getSelectedRates,
        getPremierTier,
        setSelectedRates,
        resetSelectedRates,
        getPhoneNumber,
        confirmRates,
        getSelectedState,
        setSelectedState,
    };

    function getSelectedState() {
        return _selectedState;
    }

    function setSelectedState(selectedState) {
        _selectedState = selectedState;
    }

    function getPhoneNumber() {
        return '844-722-7759';
    }
    function getCurrentDate() {
        return _currentDate;
    }

    function getServiceStates() {
        if (_states !== null) {
            return $q((resolve) => {
                resolve(_states);
            });
        }
        return $http({
            url: `${HPConfig.heroProApi}Organization/ServiceStates`,
            method: 'GET',
        }).then((response) => {
            _states = response.data.Data.States;
            _currentDate = response.data.Date;
            return _states;
        }).catch(response => $q.reject(response.data));
    }

    function getDefaultPlanRates() {
        return $http({
            url: `${HPConfig.heroProApi}Organization/CurrentRates`,
            method: 'GET',
        }).then((response) => {
            setCurrentRates(response.data.Data);
            setScheduledRates(response.data.Data);
            return response.data.Data;
        }).catch(response => $q.reject(response.data.Data));
    }

    function sortRatesByTerm(terms) {
        return _.sortBy(terms, 'Term');
    }

    function setCurrentRates(data) {
        if (data.CurrentRates !== undefined) {
            _currentRates = [];
            _.each(data.CurrentRates, (rate) => {
                rate.TermSets[0].PlanTermSets[0].Terms = sortRatesByTerm(rate.TermSets[0].PlanTermSets[0].Terms);
                _currentRates[rate.StateGeoId] = rate.TermSets[0];
                _currentRates[rate.StateGeoId].canEditRates = rate.CanEditRates;
                convertRatePlanDates(rate.TermSets[0]);
            });
        }
    }

    function getCurrentRates(stateGeoId) {
        if (stateGeoId === undefined) {
            return _currentRates;
        }
        return _currentRates[stateGeoId];
    }

    function setScheduledRates(data) {
        if (data.ScheduledRates !== undefined) {
            _scheduledRates = {};
            _.each(data.ScheduledRates, (rate) => {
                if (rate.TermSets !== undefined && rate.TermSets.length > 0) {
                    if (rate.TermSets[0].PlanTermSets !== undefined && rate.TermSets[0].PlanTermSets.length > 0) {
                        rate.TermSets[0].PlanTermSets[0].Terms = sortRatesByTerm(rate.TermSets[0].PlanTermSets[0].Terms);
                    }
                    _scheduledRates[rate.StateGeoId] = rate.TermSets[0];
                    convertRatePlanDates(rate.TermSets[0]);
                }
            });
        }
    }

    function getScheduledRates(stateGeoId) {
        if (stateGeoId === undefined) {
            return _scheduledRates;
        }

        return _scheduledRates[stateGeoId];
    }

    function getFinancingOptions() {
        return $http({
            url: `${HPConfig.heroProApi}Organization/FinancingOptions`,
            method: 'GET',
        });
    }

    function getAllPlanRates(stateGeoId) {
        return $http({
            url: `${HPConfig.heroProApi}Plan/AllRates`,
            method: 'GET',
            params: { stateGeoId },
        }).then((response) => {
            setAllRates(response.data.Data);
            return response.data.Data;
        }).catch(response => $q.reject(response.data.Data));
    }

    function getPremierTier() {
        return $http({
            url: `${HPConfig.heroProApi}Contractor/GetPremierTier`,
            method: 'GET',
        }).then((response) => {
            _premierTier = response.data.Data;
            return _premierTier;
        }).catch(response => $q.reject(response.data.Data));
    }

    function convertRatePlanDates(ratePlan) {
        _.each(ratePlan.PlanTermSets, (rates) => {
            if (rates.DisplayDate) {
                rates.DisplayDate = new Date(rates.DisplayDate);
            }
            if (rates.EndDate) {
                rates.EndDate = new Date(rates.EndDate);
            }
            if (rates.StartDate) {
                rates.StartDate = new Date(rates.StartDate);
            }
        });
    }

    function setAllRates(data) {
        if (!_.isEmpty(data) && data[0].TermSets !== undefined) {
            if (_allRates[data[0].StateGeoId] !== undefined) {
                _allRates[data[0].StateGeoId] = {};
            }

            const tempArray = [];

            _.each(data[0].TermSets, (rate) => {
                if (!_.isEmpty(_currentRates) &&
                    !_.isEmpty(_currentRates[data[0].StateGeoId]) &&
                    rate.TermSetId === _currentRates[data[0].StateGeoId].TermSetId) {
                    tempArray.unshift(rate);
                    rate.status = 'current';
                } else {
                    tempArray.push(rate);
                    rate.status = '';
                }
                convertRatePlanDates(rate);
                rate.isSelected = false;
            });

            _allRates[data[0].StateGeoId] = tempArray;
        }
    }

    function getAllRates(stateGeoId) {
        return _allRates[stateGeoId];
    }

    function setSelectedRates(selectedRates, stateGeoId) {
        _.each(_allRates[stateGeoId], (rate) => {
            if (rate.TermSetId === selectedRates.TermSetId) {
                rate.isSelected = true;
            } else {
                rate.isSelected = false;
            }
        });

        if (selectedRates !== undefined) {
            if (_selectedRates[stateGeoId] !== undefined) {
                _selectedRates[stateGeoId] = {};
            }
            _selectedRates[stateGeoId] = selectedRates;
        }
    }

    function getSelectedRates(stateGeoId) {
        if (stateGeoId === undefined) {
            return _selectedRates;
        }

        return _selectedRates[stateGeoId];
    }

    function resetSelectedRates() {
        _selectedRates = {};
    }

    function confirmRates(selectedDate) {
        return $http({
            url: `${HPConfig.heroProApi}Organization/ScheduleRates`,
            method: 'POST',
            data: {
                SelectedRates: _selectedRates,
                EffectiveDate: selectedDate,
            },
        }).then((response) => {
            angular.copy(_selectedRates, _scheduledRates);
            _selectedRates = {};
            return response.data.Data;
        }).catch(response => $q.reject(response.data));
    }
}



// WEBPACK FOOTER //
// ./src/app/accounts/financing/financingFactory.js